import $http from "@/plugins/axios";

const SessionService = {
    currentSessionOverview(botCode, channels) {
        return $http.get(`/live-support/current-sender-session/${botCode}?channels=${channels}`)
    }
}

export default SessionService